/**
 * @generated SignedSource<<dfc3b879be3fccad534545f8992c1e67>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
import { DateTime } from "@/common/relayCustomScalar";
import { Semver } from "@/common/relayCustomScalar";
import { UsernameOrID } from "@/common/relayCustomScalar";
export type UpdateDatasetVersionInput = {
  authors?: ReadonlyArray<DatasetVersionAuthorInput> | null | undefined;
  description?: string | null | undefined;
  license?: string | null | undefined;
  version?: Semver | null | undefined;
};
export type DatasetVersionAuthorInput = {
  registered: UsernameOrID;
  unregistered?: never;
} | {
  registered?: never;
  unregistered: UnregisteredDatasetVersionAuthorInput;
};
export type UnregisteredDatasetVersionAuthorInput = {
  fullName: string;
};
export type DatasetVersionPublishButtonMutation$variables = {
  id: string;
  input: UpdateDatasetVersionInput;
};
export type DatasetVersionPublishButtonMutation$data = {
  readonly publishDatasetVersion: {
    readonly id: string;
    readonly publishedAt: DateTime | null | undefined;
    readonly " $fragmentSpreads": FragmentRefs<"datasetVersionAuthorsFragment">;
  };
  readonly updateDatasetVersion: {
    readonly id: string;
  };
};
export type DatasetVersionPublishButtonMutation = {
  response: DatasetVersionPublishButtonMutation$data;
  variables: DatasetVersionPublishButtonMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = {
  "kind": "Variable",
  "name": "datasetVersionId",
  "variableName": "id"
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = [
  (v2/*:: as any*/)
],
v4 = {
  "alias": null,
  "args": [
    (v1/*:: as any*/),
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ],
  "concreteType": "DatasetVersion",
  "kind": "LinkedField",
  "name": "updateDatasetVersion",
  "plural": false,
  "selections": (v3/*:: as any*/),
  "storageKey": null
},
v5 = [
  (v1/*:: as any*/)
],
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "publishedAt",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "DatasetVersionPublishButtonMutation",
    "selections": [
      (v4/*:: as any*/),
      {
        "alias": null,
        "args": (v5/*:: as any*/),
        "concreteType": "DatasetVersion",
        "kind": "LinkedField",
        "name": "publishDatasetVersion",
        "plural": false,
        "selections": [
          (v2/*:: as any*/),
          (v6/*:: as any*/),
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "datasetVersionAuthorsFragment"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "DatasetVersionPublishButtonMutation",
    "selections": [
      (v4/*:: as any*/),
      {
        "alias": null,
        "args": (v5/*:: as any*/),
        "concreteType": "DatasetVersion",
        "kind": "LinkedField",
        "name": "publishDatasetVersion",
        "plural": false,
        "selections": [
          (v2/*:: as any*/),
          (v6/*:: as any*/),
          {
            "alias": null,
            "args": [
              {
                "kind": "Literal",
                "name": "first",
                "value": 10
              }
            ],
            "concreteType": "DatasetVersionAuthorConnection",
            "kind": "LinkedField",
            "name": "authors",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "totalCount",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "DatasetVersionAuthorConnectionEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "__typename",
                        "storageKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v2/*:: as any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "displayName",
                            "storageKey": null
                          }
                        ],
                        "type": "User",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "fullName",
                            "storageKey": null
                          }
                        ],
                        "type": "UnregisteredUser",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": (v3/*:: as any*/),
                        "type": "Node",
                        "abstractKey": "__isNode"
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "PageInfo",
                "kind": "LinkedField",
                "name": "pageInfo",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "endCursor",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": "authors(first:10)"
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "9632781d50bbf946d812e17fc9549b05",
    "id": null,
    "metadata": {},
    "name": "DatasetVersionPublishButtonMutation",
    "operationKind": "mutation",
    "text": "mutation DatasetVersionPublishButtonMutation(\n  $id: ID!\n  $input: UpdateDatasetVersionInput!\n) {\n  updateDatasetVersion(datasetVersionId: $id, input: $input) {\n    id\n  }\n  publishDatasetVersion(datasetVersionId: $id) {\n    id\n    publishedAt\n    ...datasetVersionAuthorsFragment\n  }\n}\n\nfragment datasetVersionAuthorsFragment on DatasetVersion {\n  authors(first: 10) {\n    totalCount\n    edges {\n      node {\n        __typename\n        ... on User {\n          id\n          displayName\n        }\n        ... on UnregisteredUser {\n          fullName\n        }\n        ... on Node {\n          __isNode: __typename\n          id\n        }\n      }\n    }\n    pageInfo {\n      endCursor\n    }\n  }\n  id\n}\n"
  }
};
})();

(node as any).hash = "25062ddbf2b2e52bcbd4d00c447615c9";

export default node;
